import { render, staticRenderFns } from "./Prefooter.vue?vue&type=template&id=b2738068&scoped=true&"
import script from "./Prefooter.vue?vue&type=script&lang=js&"
export * from "./Prefooter.vue?vue&type=script&lang=js&"
import style0 from "./Prefooter.vue?vue&type=style&index=0&id=b2738068&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2738068",
  null
  
)

export default component.exports